// import { put } from 'redux-saga/effects';
// import { getCommonRequest } from 'modules/common/store/dfdunk'
// import { getDfdunkTab, getDfdunkLogo, getDfdunkSns, fetchCurrencyRate } from 'modules/common/actions/commonRequest';
export function* basicConfigSaga() {
  // yield put(getDfdunkTab());
  // yield put(getDfdunkLogo());
  // yield put(getDfdunkSns());
  // yield put(fetchCurrencyRate());
}
